export default "/arrow-right-line.505af82ba70c9e8ae1ca433d67410430.svg";